import React, { useEffect } from "react";
import Title from "./Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { RecentProjectsData } from "../data";
import { useProductsContext } from "../context/Context";
import gsap from "gsap";

const Projects = () => {
  const { CursorBig, CursorSmall, showCurText, hideCurText } =
    useProductsContext();

  useEffect(() => {
    gsap.from(".swiper .projects__item", {
      y: 300,
      opacity: 0,
      delay: 0.5,
      duration: 1,
      stagger: 0.5,
    });
  }, []);

  return (
    <section className="projects swiper">
      <Title title="recent projects" />

      <div className="projects__wrapper row mt-5">
        <Swiper
          slidesPerView="auto"
          spaceBetween={32}
          modules={[Autoplay]}
          //   autoplay
          autoplay={{
            delay: 3000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }}
          loop={true}
          breakpoints={{
            240: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            666: {
              slidesPerView: 2,
            },
          }}
          className="overflow-visible">
          {RecentProjectsData.map((item, i) => {
            const { project_name, project_title, image_url, project_link } =
              item;

            return (
              <SwiperSlide key={i}>
                <div className="projects__item">
                  <a
                    href={project_link}
                    target="_blank"
                    className="projects__img mb-2"
                    onMouseOver={() => {
                      CursorBig();
                      showCurText("view project");
                    }}
                    onMouseOut={() => {
                      CursorSmall();
                      hideCurText();
                    }}>
                    <img src={image_url} alt={project_title} />
                  </a>
                  <a href={project_link} target="_blank">
                    <h2 className="heading title">{project_name}</h2>
                  </a>
                  <p className="text">{project_title}</p>
                  <a
                    href={project_link}
                    target="_blank"
                    className="projects__link">
                    Live Link
                  </a>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Projects;
